module.exports = __webpack_public_path__ + "static/ganesha04-3e0af9e14341d8975386b29287e23073.png";